import React, { useState, useEffect } from 'react';
import { Input, Menu, Tooltip } from 'antd';

import usePlacesAutocomplete, { getGeocode, getLatLng, getZipCode, getDetails } from 'use-places-autocomplete';
import './AddressInput.scss';
export const retrieveHousenumber = (houseNumberIncludingSuffix) => houseNumberIncludingSuffix?.match(/^\d+/)?.[0];

export const retrieveSuffixFromHousenumber = (houseNumber) => {
  let stripped = houseNumber?.match(/^\d+/)?.[0];

  let suffix = houseNumber?.slice(stripped.length) || '';
  return suffix || '';
};
export const retrieveSuffix = (address) => {
  if (address === '') return '';
  let houseNumber = '',
    suffix = '';

  if (!address) {
    return suffix;
  }
  const split = address.split(' ');
  if (split.length < 2) {
    return suffix;
  }
  if (/\d+/.test(split[split.length - 2])) {
    // ends with housenumber <space> suffix
    houseNumber = split[split.length - 2];
    suffix = ' ' + split[split.length - 1];
  } else if (/[\da-zA-Z\-/]+/.test(split[split.length - 1])) {
    // houseNumber and suffix one word
    houseNumber = split[split.length - 1]?.match(/^\d+/)?.[0];
    suffix = split[split.length - 1].slice(houseNumber.length);
  }

  return suffix;
};

const getAddressObject = ({ details, postalCode, suffix }) => ({
  street: details.address_components.find((l) => l.types.includes('route'))?.short_name,
  houseNumber: retrieveHousenumber(
    details.address_components.find((l) => l.types.includes('street_number'))?.short_name,
  ),
  postalCode: postalCode,
  suffix:
    retrieveSuffixFromHousenumber(
      details.address_components.find((l) => l.types.includes('street_number'))?.short_name,
    ) ||
    suffix ||
    '',
  city: details.address_components.find((l) => l.types.includes('locality'))?.short_name,
  countryCode: details.address_components.find((l) => l.types.includes('country'))?.short_name,
});

const FormattedAddress = ({ addressObject }) => {
  return addressObject?.street ? (
    <>
      {addressObject.street}
      {addressObject?.houseNumber || ''}
      {addressObject?.suffix || ''} <br />
      {addressObject.postalCode} {addressObject.city} {addressObject.countryCode}
      <br />
    </>
  ) : null;
};
const AddressInput = ({ value, onChange, onSelect, ...props }) => {
  const [address, setAddress] = useState(value?.address ?? '');
  const [addressObject, setAddressObject] = useState(value?.addressObject ?? null);
  const { suggestions, setValue, clearSuggestions } = usePlacesAutocomplete({
    debounce: 300,
  });

  useEffect(() => {
    setAddress(value?.address);
  }, [value]);

  const onChangeAddress = (event) => {
    const newAddress = event.target.value;
    setAddress(newAddress);

    setValue(newAddress);
    onChange && onChange({ address: newAddress, latLng: { lat: null, lng: null } });
  };

  const onSelectAddress = async ({ description, ...rest }) => {
    try {
      getGeocode({ address: description }).then(async (results) => {
        const details = await getDetails({ placeId: results[0].place_id });
        const postalCode = getZipCode(results[0]);

        console.log({ details });
        const suffix = retrieveSuffix(rest?.structured_formatting?.main_text || '');

        const addressObject = getAddressObject({ details, postalCode, suffix });
        const { lat, lng } = getLatLng(results[0]);

        setAddress(description);
        console.log({ addressObject });
        if (addressObject) {
          setAddressObject(addressObject);
        }
        onSelect && onSelect({ address: description, addressObject, latLng: { lat, lng } });
      });
    } catch (error) {
      console.error('Error', error);
    }
  };

  return (
    <div>
      <Tooltip title={FormattedAddress({ addressObject })}>
        <Input value={address} onChange={onChangeAddress} autoComplete="no" {...props} />
      </Tooltip>

      {suggestions && suggestions?.data.length > 0 && (
        <div className="autocomplete-dropdown-container">
          <Menu mode="vertical">
            {suggestions?.data?.map((suggestion, index) => {
              const className = suggestion.active ? 'suggestion-item--active' : 'suggestion-item';
              const style = {
                cursor: 'pointer',
              };
              return (
                <Menu.Item key={index}>
                  <div
                    className={className}
                    style={style}
                    key={suggestion.description}
                    onClick={() => {
                      onSelectAddress(suggestion);
                      clearSuggestions();
                    }}
                  >
                    <span>{suggestion.description}</span>
                  </div>
                </Menu.Item>
              );
            })}
          </Menu>
        </div>
      )}
    </div>
  );
};

export default AddressInput;
